import React, { useEffect, useState } from "react";
import { isEmpty } from "lodash";
import { useLeaveStore } from "../../../config/stores";
import LeaveApplicationForm from "./ManageMyLeaveApplications/LeaveApplicationForm";
import TableTitle from "../../../components/common/TableTitle";
import AntdTable from "../../../components/common/AntdTable";
import { searchTable } from "../../../config/constants";
import dayjs from "dayjs";
import LeaveApplicationStatus, {
  canModifyLeave,
} from "../../../components/administration/leave/LeaveApplicationStatus";
import TableButtonActions from "../../../components/common/TableButtonActions";
import LeaveApplicationDetails from "./ManageMyLeaveApplications/LeaveApplicationDetails";

const MyLeaveApplications = () => {
  const [filterTable, setFilterTableNull] = useState(null);
  const [deleteId, setDeleteId] = useState(null);
  const leaveStore = useLeaveStore();

  useEffect(() => {
    if (isEmpty(leaveStore.myApplications)) {
      leaveStore.getMyLeaveApplications();
    }
  }, []);

  const handleView = (id, record) => {
    const applicationId = id || record?.id || record?.Id || record?.ID;

    if (applicationId) {
      leaveStore.getLeaveApplicationDetails(applicationId);
    } else if (record && typeof record === "object") {
      leaveStore.setSelectedApplication(record);
      leaveStore.setShowLeaveApplicationDetails(true);
    }
  };

  const handleEdit = (record) => {
    leaveStore.setAddingLeaveApplication(true, true, record);
  };

  const handleDelete = (id) => {
    setDeleteId(id);
  };

  const confirmDelete = () => {
    leaveStore.deleteLeaveApplication(deleteId);
    setDeleteId(null);
  };

  const search = (value) => {
    const filterTable = searchTable(leaveStore.myApplications?.data || [], value);
    setFilterTableNull(filterTable);
  };

  const openAddModal = () => {
    leaveStore.setAddingLeaveApplication(true, true, {});
  };

  const refreshTable = () => {
    leaveStore.getMyLeaveApplications();
  };

  if (leaveStore.loading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="container-fluid p-2">
      <h5 className="fw-bold">MY LEAVE APPLICATIONS</h5>

      {leaveStore.showLeaveApplicationDetails ? (
       <LeaveApplicationDetails />
      ) : (
        <AntdTable
          loading={leaveStore.gettingMyApplications}
          title={() => (
            <TableTitle
              setFilterTableNull={setFilterTableNull}
              openAddModal={openAddModal}
              refreshTable={refreshTable}
              search={search}
            />
          )}
          pageSize={20}
          data={filterTable === null ? leaveStore.myApplications?.data || [] : filterTable}
          columns={[
            {
              title: "Leave Details",
              render: (record) => (
                <div>
                  <span className="d-md-none">Leave Type:</span>
                  <span
                    className="text-primary cursor-pointer"
                    onClick={() => handleView(record?.id, record)}
                  >
                    {record.leave_type === "OTHER" ? record.other_leave_type : record.leave_type}
                  </span>
                  <br />
                  <div className="d-md-none">
                    <span>Period: {dayjs(record.start_date).format("DD/MM/YYYY")} - {dayjs(record.end_date).format("DD/MM/YYYY")}</span>
                    <br />
                    <span>Days: {record.number_of_days}</span>
                    <br />
                    <span>Balance: {record.balance_after_leave}</span>
                    <br />
                    <span>Status: <LeaveApplicationStatus status={record.status} /></span>
                    <br />
                    Actions:
                    <TableButtonActions
                      record={record}
                      confirmDelete={confirmDelete}
                      deleteLoading={leaveStore.deleting}
                      viewDetails={handleView}
                      updateRecord={canModifyLeave(record.status) ? handleEdit : null}
                      deleteId={deleteId}
                      deleteRecord={canModifyLeave(record.status) ? handleDelete : null}
                    />
                  </div>
                </div>
              ),
            },
            {
              title: "Start Date",
              dataIndex: "start_date",
              key: "start_date",
              render: (date) => dayjs(date).format("DD/MM/YYYY"),
              responsive: ["md"],
            },
            {
              title: "End Date",
              dataIndex: "end_date",
              key: "end_date",
              render: (date) => dayjs(date).format("DD/MM/YYYY"),
              responsive: ["md"],
            },
            {
              title: "Days",
              dataIndex: "number_of_days",
              key: "number_of_days",
              responsive: ["md"],
            },
            {
              title: "Leave Balance",
              dataIndex: "balance_after_leave",
              key: "balance_after_leave",
              responsive: ["md"],
            },
            {
              title: "Contact",
              render: (record) => (
                <div>
                  <div>Address: {record.address_while_on_leave}</div>
                  <div>Phone: {record.phone_while_on_leave}</div>
                </div>
              ),
              responsive: ["md"],
            },
            {
              title: "Status",
              dataIndex: "status",
              key: "status",
              render: (status) => <LeaveApplicationStatus status={status} />,
              responsive: ["md"],
            },
            {
              title: "Actions",
              key: "actions",
              responsive: ["md"],
              render: (record) => (
                <TableButtonActions
                  record={record}
                  confirmDelete={confirmDelete}
                  deleteLoading={leaveStore.deleting}
                  viewDetails={handleView}
                  updateRecord={canModifyLeave(record.status) ? handleEdit : null}
                  deleteId={deleteId}
                  deleteRecord={canModifyLeave(record.status) ? handleDelete : null}
                />
              ),
            },
          ]}
        />
      )}

      <LeaveApplicationForm />
    </div>
  );
};

export default MyLeaveApplications; 